import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "@/css/customtheme.scss";
import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faBell,
    faCoins,
    faFileInvoice,
    faFileLines,
    faGear,
    faGears,
    faSignOut,
    faTasks,
    faUserGroup,
    faUsers
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import 'vue-slider-component/theme/antd.css'
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'
import createI18n from "./i18n"
import { bootstrapThemeMode, initThemeMode } from "@/utils/themeMode";
import { logger } from "@/utils/logger";
import { initSentry } from "@/utils/sentry";

bootstrapThemeMode();

library.add(faGear, faGears, faSignOut, faBell, faTasks, faUserGroup, faUsers, faCoins, faFileInvoice, faFileLines);

//configure i18n
export const i18n = createI18n;

const app = createApp(App)
    .use(i18n)
    .use(Quasar, quasarUserOptions)
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(store)
    .use(router);

// Initialize Sentry for error tracking (production)
initSentry(app);


app.config.errorHandler = (error: any, instance: any, info: string) => {
  const errorMessage = error instanceof Error ? error.message : String(error);
  
  logger.error(
    `Vue Error: ${info}`,
    error instanceof Error ? error : new Error(errorMessage),
    {
      component: instance?.$options?.name || 'Unknown',
      info,
    }
  );
};

/**
 * GLOBAL WARNING HANDLER
 * Suppresses non-critical Vue warnings in production
 */
app.config.warnHandler = (message: string, instance: any, trace: string) => {
  // Suppress common non-critical warnings
  if (message.includes('Avoid app logic that relies on enumerating keys') ||
      message.includes('Avoid app logic that relies on enumerating')) {
    return;
  }
  
  logger.warn(`Vue Warning: ${message}`, {
    component: instance?.$options?.name,
  });
};

initThemeMode();

app.mount('#app')

const loader = document.getElementById('capitole-loader')
if (loader) {
    loader.classList.add('capitole-loader--hide')
    window.setTimeout(() => loader.remove(), 500)
}
